import { fetchProductFromPDVInMarketResearch } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ProductFromPDVMarketResearcKeys = {
    all: ['productfrommarketresearch'] as const,
    lists: () => [...ProductFromPDVMarketResearcKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ProductFromPDVMarketResearcKeys.lists(), page, perPage, filters] as const,
    details: () => [...ProductFromPDVMarketResearcKeys.all, 'detail'] as const,
    detail: (params: string) => [...ProductFromPDVMarketResearcKeys.details(), params] as const,
}

export const useProductFromPDVMarketResearchQuery = (SK_PESQUISA: number, SK_CLIENTE: number, enableStatus: boolean) => {
    return useQuery({
        enabled: enableStatus,
        queryFn: () => fetchProductFromPDVInMarketResearch(SK_PESQUISA, SK_CLIENTE),
        queryKey: ProductFromPDVMarketResearcKeys.detail(`${SK_PESQUISA}${SK_CLIENTE}`),
    })
}
